export default __webpack_public_path__ + "static/media/pexels-francis-agyemang-opoku-10794860.85d46a66.jpg";